<template>
  <div id="contenedor">
    <!-- mensajes de confirmacion -->
    <mensajeSistema></mensajeSistema>

    <!-- MODAL DE ASISTENCIA DE ALUMNOS -->
    <v-dialog max-width="50%" v-model="modal_asistencia">
      <v-card>
        <v-card-title class="primary">
          <h3 class="text-white">ASISTENCIA A CLASE</h3>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="4">
              <v-chip class="primary">Grado: {{ gradoAsistencia }}</v-chip>
            </v-col>
            <v-col cols="4">
              <v-chip class="primary">Sección: {{ seccionAsistencia }}</v-chip>
            </v-col>
          </v-row>
          <v-row class="mb-5">
            <v-col cols="12">
              <v-card class="mb-5">
                <v-data-table :headers="headers_asistencia" :items="Asistencias" :search="search"
                  class="elevation-1 tabla">
                  <template v-slot:[`item.estadoAsistencia`]="{ item }">
                    <v-chip v-if="item.estado_asistencia === null">Sin asistencia</v-chip>
                    <v-chip :style="{
                      background: item.color_est_asistencia,
                    }" dark v-else>{{ item.estado_asistencia }}</v-chip>
                  </template>
                  <template v-slot:[`item.observacion`]="{ item }">
                    <v-menu absolute offset-y style="max-width: 600px">
                      <template v-slot:activator="{ on }">
                        <v-row justify="space-around" v-on="on">
                          <span v-if="item.observacion_asistencia === null"><v-chip color="error">Sin
                              Observación</v-chip></span>
                          <v-btn text v-else><v-icon color="primary">fa-comment-dots</v-icon></v-btn>
                        </v-row>
                      </template>
                      <v-card max-width="250px" class="py-2 px-2">
                        <v-tooltip bottom color="#1b1b1b">
                          <template v-slot:activator="{ on }" v-on="on">
                            {{ item.observacion_asistencia }}
                          </template>
                        </v-tooltip>
                      </v-card>
                    </v-menu>
                  </template>
                  <template v-slot:[`item.justificacion`]="{ item }">
                    <v-chip v-if="item.archivo_asistencia === null">Sin justificación</v-chip>
                    <v-chip class="primary" v-else><a :href="ruta_api +
                      item.ruta_aasistencia +
                      item.archivo_asistencia
                      " target="_blank" style="color: #fff; text-decoration: none">{{ item.archivo_alumno
  }}</a></v-chip>
                  </template>
                </v-data-table>
              </v-card>
            </v-col>
            <v-col cols="12" class="text-right"><v-chip class="primary">TOTAL DE ESTUDIANTES ASISTIDOS {{ asistentes }}/{{
              Asistencias.length
            }}</v-chip></v-col>
          </v-row>
          <v-row>
            <v-col class="text-right">
              <v-btn class="error" @click="modal_asistencia = false">
                VOLVER</v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- BOTÓN CREAR -->
    <v-row>
      <v-col cols="12" class="d-flex justify-end">
        <ButtonComp normalButton @click="generarExcel" :disabled="inhabilitarSeccion" iconBut="fas fa-file-excel"
          textButton="Generar horario" classButton="mr-2" />
        <ButtonComp normalButton @click="verCalendario" :disabled="ProgramacionDoc.length === 0"
          textButton="Ver calendario" iconBut="fas fa-calendar" />
      </v-col>

    </v-row>

    <!-- PANTALLA PRINCIPAL DE PROGRAMACION DOCENTE -->
    <v-row>
      <v-col cols="12" sm="4" md="4" lg="2">
        <AutocompleteComp textLabel="Docente" v-model="filtroProgDoc.id" :items="Docentes" item-value="id_personal"
          item-text="docente" @change="getNivelesDocente(filtroProgDoc.id)" />

      </v-col>
      <v-col cols="12" sm="4" md="4" lg="2">
        <AutocompleteComp textLabel="Nivel" v-model="filtroProgDoc.id_nivel" :items="NivelesDoc"
          :disabled="inhabilitarNivel" autocomplete="off" item-value="id_adm_nivel" item-text="nombre_nivel"
          @change="getGradosDocente(filtroProgDoc.id_nivel)" />

      </v-col>
      <!-- @change="eventNivelDoc" -->
      <v-col cols="12" sm="4" md="4" lg="2">
        <AutocompleteComp textLabel="Grado" v-model="filtroProgDoc.id_grado" :items="GradosDoc"
          :disabled="inhabilitarGrado" autocomplete="off" item-value="id_adm_grado" item-text="nombre_grado"
          @change="getAllAreasDocente(filtroProgDoc.id_grado)" />

      </v-col>
      <v-col cols="12" sm="4" md="4" lg="2">
        <AutocompleteComp textLabel="Sección" v-model="id_seccion" :items="SeccionesDoc" :disabled="inhabilitarSeccion"
          autocomplete="off" item-value="id_seccion" item-text="nombre_seccion"
          @change="getAllProgramacionSeccion(id_seccion)" />

      </v-col>
      <!-- @change="eventGradoDoc" -->
      <v-col cols="12" sm="4" md="4" lg="2">
        <AutocompleteComp textLabel="Área" v-model="filtroProgDoc.id_area" :items="AreasDoc"
          :disabled="inhabilitarAreaDoc" autocomplete="off" item-value="id_adm_area" item-text="nombre_area"
          @change="getCursosDocente(filtroProgDoc.id_area)" />

      </v-col>

      <v-col cols="12" sm="4" md="4" lg="2">
        <AutocompleteComp textLabel="Curso" v-model="filtroProgDoc.id_curso" :items="CursosDoc"
          :disabled="inhabilitarCursoDoc" autocomplete="off" item-value="id_adm_curso" item-text="nombre_curso"
          @change="eventCursoDoc" />

      </v-col>



    </v-row>
    
    <v-row>
      <v-col cols="12">
        <ComundataTablecomp :headers="supervisionDocenteDirector" :items="filteredData" whitSearch :search="filtroTabla"
          noResultsText="Sin clases registradas">
          <template v-slot:fecha="{ item }">
            <div v-if="item.fecha != null">
              {{ item.fecha | filtroFecha }}          
            </div>
            <div v-else>
              -----
            </div>
          </template>

          <template v-slot:curso_desc="{ item }">
            <v-chip small dark :color="item.color_curso" class="my-3">
              <v-icon left small>{{ item.icono_curso }}</v-icon>
              {{ item.desc_curso }}
            </v-chip>
          </template>

          <template v-slot:hora_inicio="{ item }">
            <div v-if="item.hora_inicio != null">
              {{ item.hora_inicio | filtroFormatoHora }}       
            </div>
            <div v-else>
              -----
            </div>
          </template>
          
          <template v-slot:hora_fin="{ item }">
            <div v-if="item.hora_fin != null">
              {{ item.hora_fin | filtroFormatoHora }}       
            </div>
            <div v-else>
              -----
            </div>
          </template>

          <template v-slot:id_estado="{ item }">
            <v-chip :style="{ background: item.color_estado || 'red' }" dark>
              {{ item.desc_estado || 'No programado' }}
            </v-chip>
          </template>
          <template v-slot:id_clase="{ item }">
            <ButtonComp verButton tooltipText="Ver clase" @click="visualizarClase(item.id_clase, item.tipo_contenido)" />
          </template>
          <template v-slot:seguimiento_val="{ item }">
            <ButtonComp list-button @click="verSeguimiento(item)" tooltipText="Seguimiento de programación docente" />

            <!-- 
            <v-tooltip bottom color="#1b1b1b">
              <template v-slot:activator="{ on }">
                <v-btn v-on="on" class="btn_imprimir" fab x-small >
                  <v-icon small>fa-clipboard-list</v-icon>
                </v-btn>
              </template>
              <span>Seguimiento de {{ $t("titulo.progDocente").toLowerCase() }}</span>
            </v-tooltip> -->
          </template>

          <template v-slot:sesion_val="{ item }">
            <ButtonComp @click="GenerarDocumentoSa(item.id_sa)" download-button
              tooltip-text="Ver sesión de aprendizaje" />

            <!-- <v-tooltip bottom color="#1b1b1b">
              <template v-slot:activator="{ on }">
                <v-btn color="primary" class="btn_otro" fab x-small v-on="on" >
                  <v-icon small>fa-file-download</v-icon>
                </v-btn>
              </template>
              <span>Ver sesión de aprendizaje</span>
            </v-tooltip> -->
          </template>

          <template v-slot:clasv_val="{ item }">
            <v-tooltip bottom v-if="componenteEvento.visualizar_submodulo && item.clase_virtual
              ">
              <template v-slot:activator="{ on }">
                <v-btn v-on="on" class="mx-2 btn_virtual" @click="
                  verClaseVirtual(
                    item.enlace_virtual,
                    item.fecha,
                    item.hora_inicio,
                    item.hora_fin,
                    item.id_estado
                  )
                  " :disabled="item.id_estado == 3 || !item.id_sa ||
                      item.id_estado == 4 ||
                      moment(item.fecha).format('YYYY-DD-MM') !=
                      moment().format('YYYY-DD-MM')
                      " target="_blank" fab x-small>
                  <v-icon small>fa-video</v-icon>
                </v-btn>
              </template>
              <span>Ver clase virtual</span>
            </v-tooltip>
            <v-tooltip bottom v-if="!item.clase_virtual">
              <template v-slot:activator="{ on }">
                <v-btn v-on="on" class="mx-2 btn_deshabilitar" :disabled="item.id_estado == 3 || item.id_estado == 4" fab
                  x-small>
                  <v-icon small>fa-video-slash</v-icon>
                </v-btn>
              </template>
              <span>No tiene clase virtual</span>
            </v-tooltip>
          </template>
          <template v-slot:grabcion_val="{ item }">
            <v-tooltip bottom v-if="componenteEvento.visualizar_submodulo &&
              item.clase_virtual_video == 1
              ">
              <template v-slot:activator="{ on }">
                <v-btn v-on="on" class="mx-2 btn_eliminar" fab x-small v-if="item.clase_virtual_video_enlace == null"
                  disabled>
                  <v-icon>fa-play</v-icon>
                </v-btn>
                <v-btn v-on="on" class="mx-2 btn_eliminar" fab x-small v-else :href="item.clase_virtual_video_enlace"
                  target="_blank">
                  <v-icon small>fa-play</v-icon>
                </v-btn>
              </template>
              <span>Ver video de clase grabada</span>
            </v-tooltip>

            <v-tooltip bottom>
              <template v-slot:activator="{ on }" v-if="item.clase_virtual_video == 0 || item.clase_virtual_video == null">
                <v-btn v-on="on" class="mx-2" disabled fab x-small>
                  <v-icon small>fa-play</v-icon>
                </v-btn>
              </template>
              <span> No tiene video de clase grabada</span>
            </v-tooltip>
          </template>


        </ComundataTablecomp>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <v-chip label class="mx-2 programada-est" dark>PROGRAMADAS: {{ contProgramada }}</v-chip>
        <v-chip label class="mx-2 noProgramada-est" dark> NO PROGRAMADAS: {{ contNoProgramada }}</v-chip>
        <v-chip label class="mx-2 ejecutada-est" dark>EJECUTADAS: {{ contEjecutada }}</v-chip>
        <v-chip label class="mx-2 sinejecutar-est" dark>SIN EJECUTAR: {{ contSinejecutar }}</v-chip>
        <v-chip label class="mx-2 reprogramada-est" dark>REPROGRAMADAS: {{ contReprogramada }}</v-chip>
        <v-chip label class="mx-2 actualizada-est" dark>ACTUALIZADAS: {{ contActualizada }}</v-chip>
        <v-chip label class="mx-2 " color="primary" dark>TOTAL: {{ ProgramacionDoc.length }}</v-chip>
      </v-col>
    </v-row>

    <v-form ref="formDatos" lazy-validation>
      <v-dialog v-model="modal_asociarClase" persistent scrollable max-width="90%">
        <v-card>
          <v-card-title class="btn_otro">
            <v-row class="d-flex justify-space-between py-0">
              {{ formTitle }}
              <v-btn fab dark x-small class="btn_style3" @click="modal_asociarClase = false"><v-icon
                  dark>fa-times</v-icon></v-btn>
            </v-row>
          </v-card-title>

          <v-divider></v-divider>

          <v-card-text>
            <v-row class="mt-2">
              <v-col cols="12" sm="3" md="auto" class="py-0">
                <span style="font-size: 16px">Contenidos</span>
                <v-radio-group v-model="asociarCl.contenidoTipo" @change="cargarQueryContenido" row class="mt-0">
                  <v-radio :label="`Clicken1`" :value="1"></v-radio>
                  <v-radio :label="`Colegio`" :value="0"></v-radio>
                </v-radio-group>
              </v-col>

              <v-col cols="12" sm="3" md="" class="py-0">
                <v-autocomplete label="Nivel" v-model="asociarCl.id_nivel" :items="nivelCont" :item-value="id_nivelFiltro"
                  item-text="desc_nivel" @change="eventNivelCl" :disabled="inhabilitarNivelCl" autocomplete="off" dense>
                </v-autocomplete>
              </v-col>

              <v-col cols="12" sm="3" md="" class="py-0">
                <v-autocomplete label="Grado" v-model="asociarCl.id_grado" :items="gradoContFilter"
                  :item-value="id_gradoFiltro" item-text="desc_grado" @change="eventGradoCl"
                  :disabled="inhabilitarGradoCl" autocomplete="off" dense>
                </v-autocomplete>
              </v-col>

              <v-col cols="12" sm="3" md="" class="py-0">
                <v-autocomplete label="Área" v-model="asociarCl.id_area" :items="areaContFilter"
                  :item-value="id_areaFiltro" item-text="desc_area" @change="eventAreaCl" :disabled="inhabilitarAreaCl"
                  autocomplete="off" dense>
                </v-autocomplete>
              </v-col>

              <v-col cols="12" sm="3" md="" class="py-0">
                <v-autocomplete :label="$t('titulo.curso')" v-model="asociarCl.id_curso" :items="cursoContFilter"
                  :item-value="id_cursoFiltro" item-text="desc_curso" @change="cargarClases"
                  :disabled="inhabilitarCursoCl" autocomplete="off" dense>
                </v-autocomplete>
              </v-col>

              <v-col cols="4" md="" class="py-0">
                <v-text-field label="Buscar" v-model="search_asociarCl" append-icon="fa-search" single-line
                  hide-details></v-text-field>
              </v-col>
            </v-row>
            <!-- {{clasesColegio}}

                        {{clases}} -->
          </v-card-text>
          <!--
                    <pre>Matriz: {{asociarCl}}</pre>
                    <pre>Programar Clase: {{programarCl}}</pre>
                    -->

          <!--
                        <pre>Clases: {{clases}}</pre>
                    -->
        </v-card>
      </v-dialog>
    </v-form>

    <!-- MODAL DE TAREAS ASIGNADAS -->
    <v-dialog max-width="60%" v-model="modal_tareas">
      <v-card>
        <v-card-title class="primary">
          <v-row>
            <v-col>ACTIVIDADES ASIGNADA</v-col>
          </v-row>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="4" class="text-center">
              <v-chip>
                <h4>Clase: Nombre de la Clase</h4>
              </v-chip>
            </v-col>
            <v-col cols="4" class="text-center">
              <v-select :items="Actividades" item-text="desc_actividad" label="Nivel:" persistent-hint
                prepend-icon=""></v-select>
            </v-col>
            <v-col cols="4" class="text-center">
              <h4>Fecha Tope de Entrega: 05/05/2020</h4>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-card>
                <v-data-table :headers="headers_tareas" :search="search" class="elevation-1 tabla">
                </v-data-table>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-col class="text-right"><v-btn class="" dark color="error"
              @click="modal_tareas = false">VOLVER</v-btn></v-col>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-form ref="formDatosProgramar" lazy-validation>
      <v-dialog v-model="modal_programarClase" persistent scrollable max-width="40%">
        <v-card>
          <v-card-title class="btn_otro">
            <v-row class="d-flex justify-space-between py-0">
              {{ programarCl.titulo }}
              <v-btn fab dark x-small class="btn_style3" @click="modal_programarClase = false"><v-icon
                  dark>fa-times</v-icon></v-btn>
            </v-row>
          </v-card-title>

          <v-divider></v-divider>

          <v-card-text>
            <v-row>
              <v-col cols="12" class="d-flex justify-center pb-0 pt-0">
                <p class="body-1 mb-0 black--text">
                  <span class="font-weight-black">Tema: </span>
                  {{ programarCl.nombre_tema }} -
                  <span class="font-weight-black">Clase: </span>
                  {{ programarCl.nombre_clase }}
                </p>
              </v-col>

              <v-col cols="12" class="py-0" v-if="evento == 'editar'">
                <v-radio-group v-model="programarCl.id_estado" row class="pa-0 mb-0">
                  <v-radio :label="`Actualizar`" :value="5" @change="eventActualizar" color="#ffbc00"></v-radio>
                  <v-radio :label="`Reprogramar`" :value="2" @change="eventReprogramar" color="#ffbc00"></v-radio>
                  <v-radio :label="`Sin Ejecutar`" :value="3" @change="eventEjecutar" color="#e53935"></v-radio>
                  <v-radio :label="`Ejecutada`" :value="4" @change="eventEjecutar" color="#6abf69"></v-radio>
                </v-radio-group>
              </v-col>

              <v-col cols="12" class="pb-1 pt-0">
                <v-btn :href="ruta_api2 + programarCl.sesion_aprendizaje" v-if="programarCl.sesion_aprendizaje"
                  target="_blank" class="btn_block_style2" block small dark>
                  DESCARGAR del contenido
                </v-btn>

                <v-btn v-if="!programarCl.sesion_aprendizaje" disabled block small>
                  NO SE HA CARGADO
                  {{ $t("titulo.sessionAprendizaje") }}del contenido
                </v-btn>
              </v-col>

              <v-col cols="6" class="py-0">
                <v-select v-model="programarCl.id_nivel" :items="nivelDoc" :disabled="evento == 'editar'"
                  @change="eventNivelDocCl" item-value="id_nivel" item-text="desc_nivel" label="Nivel"
                  :rules="[rul.selectReq]">
                </v-select>
              </v-col>

              <v-col cols="6" class="py-0">
                <v-select v-model="programarCl.id_grado" :items="gradoDocFilter" :disabled="evento == 'editar'"
                  @change="eventGradoDocCl" item-value="id_grado" item-text="desc_grado" label="Grado"
                  :rules="[rul.selectReq]">
                </v-select>
              </v-col>

              <v-col cols="4" class="py-0">
                <v-select v-model="programarCl.id_area" :items="areaDocFilter" :disabled="evento == 'editar'"
                  @change="eventAreaDocCl" item-value="id_area" item-text="desc_area" label="Area"
                  :rules="[rul.selectReq]">
                </v-select>
              </v-col>

              <v-col cols="4" class="py-0">
                <v-select v-model="programarCl.id_curso" :items="cursoDocFilter" :disabled="evento == 'editar'"
                  @change="eventCursoDocCl" item-value="id_curso" item-text="desc_curso" :label="$t('titulo.curso')"
                  :rules="[rul.selectReq]">
                </v-select>
              </v-col>

              <v-col cols="4" class="py-0">
                <v-select v-model="programarCl.id_seccion" :items="seccionDocFilter" :disabled="evento == 'editar'"
                  item-value="id_seccion" item-text="desc_seccion" :label="$t('titulo.salon')" :rules="[rul.selectReq]">
                </v-select>
              </v-col>

              <v-col cols="4" class="py-0">
                <v-menu v-model="menu2" :close-on-content-click="false" transition="scale-transition" offset-y
                  max-width="290px" min-width="290px">
                  <template v-slot:activator="{ on }">
                    <v-text-field v-model="computedDateFormatted2" label="Fecha" readonly v-on="on"
                      :rules="[rul.required]" :disabled="inhabilitarFecha">
                    </v-text-field>
                  </template>

                  <v-date-picker v-model="programarCl.fecha" no-title @input="menu2 = false"></v-date-picker>
                </v-menu>
              </v-col>

              <v-col cols="4" class="py-0">
                <v-text-field v-model="programarCl.hora_inicio" label="Hora Inicio" :disabled="inhabilitarHoraInicio"
                  type="time" :rules="[rul.required]"></v-text-field>
              </v-col>

              <v-col cols="4" class="py-0">
                <v-text-field v-model="programarCl.hora_fin" label="Hora fin" :disabled="inhabilitarHoraFin" type="time"
                  :rules="[rul.required]"></v-text-field>
              </v-col>

              <v-col cols="7" class="py-0">
                <v-file-input v-model="archivoSubir" accept=".docx,.pdf,.doc" :rules="rules"
                  :disabled="inhabilitarSesionAprendisaje"></v-file-input>
              </v-col>

              <v-col cols="5">
                <v-btn class="btn_block_style2" :href="programarCl.uri" target="_self" dark small
                  v-if="evento == 'editar'">
                  Ver {{ $t("titulo.sesionAprendizaje") }}
                </v-btn>
              </v-col>

              <v-col cols="7" class="py-0">
                <v-radio-group v-model="programarCl.clase_virtual" row label="Clase Virtual"
                  :disabled="inhabilitarClaseVirtual" class="pa-0">
                  <v-radio :label="`Si`" :value="1" color="teal"></v-radio>
                  <v-radio :label="`No`" :value="0" color="error"></v-radio>
                </v-radio-group>
              </v-col>

              <v-col ccols="5">
                Estado Actual
                <v-chip small dark class="font-weight-black" :color="programarCl.color_estado">
                  {{ programarCl.desc_estado }}
                </v-chip>
              </v-col>

              <v-col cols="12" class="py-0" v-if="programarCl.clase_virtual == 1">
                <v-text-field type="text" v-model="programarCl.enlace_virtual"
                  label="Pegue aquí su enlace de Clase Virtual" :disabled="inhabilitarEnlaceVirtual"
                  prepend-icon="fas fa-link" :rules="[rul.required]"
                  :required="programarCl.clase_virtual == 1"></v-text-field>
              </v-col>

              <v-col cols="12" class="py-0" v-if="programarCl.clase_virtual_video == 1 &&
                programarCl.id_estado == 4
                ">
                <v-text-field type="text" v-model="programarCl.clase_virtual_video_enlace"
                  label="Pegue aquí su enlace de video de clase grabada" :disabled="inhabilitarClaseVirtualEnlace"
                  prepend-icon="fas fa-link" :rules="[rul.required]"
                  :required="programarCl.clase_virtual_video == 1"></v-text-field>
              </v-col>

              <v-col cols="12" class="py-0">
                <v-textarea v-model="programarCl.observacion" label="Observación" :disabled="inhabilitarObservacion"
                  rows="2"></v-textarea>
              </v-col>
            </v-row>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn class="btn_style3" dark @click="modal_programarClase = false">Cancelar</v-btn>
            <v-btn class="btn_block_style2" dark @click="saveItem">Guardar</v-btn>
          </v-card-actions>

          <!--
                        <pre>URI: {{programarCl.uri}}</pre>
                        <pre>Programar Clase: {{programarCl}}</pre>
                    -->
        </v-card>
      </v-dialog>
    </v-form>

    <v-dialog v-model="dialog_delete" width="30%">
      <v-card>
        <v-card-title class="btn_ver">
          <v-row class="d-flex justify-end py-0">
            <v-btn fab dark x-small class="btn_style3" @click="dialog_delete = false"><v-icon
                dark>fa-times</v-icon></v-btn>
          </v-row>
        </v-card-title>

        <v-card-text class="text-center">
          <h3>
            ¿Está seguro de borrar este registro
            <v-chip color="yellow font-weight-black">{{ desc_delete }}</v-chip>
            ?
          </h3>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="btn_style3" dark @click="dialog_delete = false">No</v-btn>
          <v-btn class="btn_block_style2" dark @click="deleteItem">Sí</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- MODAL DE SEGUIMIENTO O HISTORIAL -->

    <ComunDialogComp v-model="modal_seguimiento" maxWidth="1000" title="Seguimiento de clases programadas"
      @close-modal="modal_seguimiento = false">
      <template v-slot:body>
        <v-row>
          <v-timeline centered>
            <v-timeline-item v-for="(item, i) in seguimientoClase" :key="i" :color="item.color_estado" small>
              <template v-slot:opposite>
                <span class="title font-weight-bold">
                  {{ item.fec_us_ing.substr(0, 10) }}
                  {{ item.fec_us_ing.substr(11, 8) | filtroFormatoHora }}
                </span>
              </template>

              <v-card class="elevation-2" width="350">
                <v-card-title class="headline">
                  <v-chip :dark="item.desc_estado != 'Actualizada' ? true : false" class="font-weight-black"
                    :color="item.color_estado">
                    <h2>{{ item.desc_estado }}</h2>
                  </v-chip>
                </v-card-title>

                <v-card-text>
                  <p class="body-1">
                    <span class="black--text">Fecha:</span>
                    {{ item.fecha }}
                  </p>

                  <p class="body-1">
                    <span class="black--text">Hora:</span>
                    {{ item.hora_inicio | filtroFormatoHora }}
                    -
                    {{ item.hora_fin | filtroFormatoHora }}
                  </p>

                  <p class="body-1">
                    <span class="black--text">Clase virtual:</span>
                    {{ item.clase_virtual_desc }}
                  </p>

                  <p class="body-1">
                    <span class="black--text">Observación:</span>
                    {{ item.observacion }}
                  </p>
                </v-card-text>
              </v-card>
            </v-timeline-item>
          </v-timeline>
        </v-row>
      </template>
    </ComunDialogComp>

    <!-- MODAL VISOR DE CONTENIDOS -->
    <v-dialog v-model="visor" scrollable max-width="80%">
      <v-card>
        <v-card-title class="btn_otro">
          <v-row class="d-flex justify-space-between py-0">
            Contenido
            <v-btn fab dark x-small class="btn_style3" @click="cerrarVisor"><v-icon dark>fa-times</v-icon></v-btn>
          </v-row>
        </v-card-title>

        <v-divider></v-divider>

        <v-card-text class="text-center">
          <component :is="tipoVisor" :diapositivas="api_list_contenidos"></component>
          <!-- <ModalVisorCk1 :diapositivas="api_list_contenidos" ></ModalVisorCk1> -->
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- CARGAR EL COMPONENTE PARA ACTIVAR MODAL DE VER CALENDARIO -->
    <component :is="componentCalendar" :data="paramsProgramacion" @closeCalendar="closeModalCalendar"></component>

    <component :is="compName" :estadoModal="estadoModalConfig" @close="estadoModalConfig = false"
      :parametros="parametroConfigVisor">
    </component>

    <component :is="compName2" :estadoComp="estadoComponente" :parametros="parametroComp" @close="CloseModal">
    </component>

    <v-dialog v-model="modalSesion" persistent scrollable max-width="90%">
      <SesionAprendizaje @close="modalSesion = false" :compEstadoP="modalSesion" :compParametroP="parametroSA">
      </SesionAprendizaje>
    </v-dialog>

    <span v-if="test">
      paramsDocente: <code>{{ paramsDocente }}</code> filtro ProgDoc:
      <code>{{ filtroProgDoc }}</code>
      <br />
      FILTROS: id_nivel: <code>{{ filtroProgDoc.id_nivel }}</code> id_grado:
      <code>{{ filtroProgDoc.id_grado }}</code> id_area:
      <code>{{ filtroProgDoc.id_area }}</code> id_seccion:
      <code>{{ id_seccion }}</code> id_curso:
      <code>{{ filtroProgDoc.id_curso }}</code>
    </span>
  </div>
</template>

<script>
import axios, { API_URL, BUCKET_ORIGIN_SPACE } from "@/helpers/axios";
import { mapMutations, mapGetters, mapActions } from "vuex";
import Calendario from '@/views/Academico/GestionCoordinacion/components/Calendario'
import moment from "moment";
import SesionAprendizaje from '@/views/Academico/ProgramacionDocente/sesionAprendizaje/sesionAprendizaje.vue'
import VisorContenido from '@/views/Manager/GestionContenido/viewGC/visorGestorContenido';
import ComundataTablecomp from '../../../components/ComponentsEst/ComundataTablecomp.vue';
import ButtonComp from '../../../components/ComponentsEst/TableButtonComp.vue';
import AutocompleteComp from '../../../components/ComponentsEst/AutocompleteComp.vue';
import { supervisionDocenteDirector } from "../../../helpers/headersTable"
import ComunDialogComp from '../../../components/ComponentsEst/ComunDialogComp.vue';

export default {
  name: "gestionCooridnacion",
  components: {
    Calendario,
    VisorContenido,
    SesionAprendizaje,
    ComundataTablecomp,
    ButtonComp,
    AutocompleteComp,
    ComunDialogComp
  },

  data: (vm) => ({
    //////////////////////// NO MOVER CONFIGURACION PRINCIPAL DE CADA VISTA////////////////////////
    paramComponente: { id_submodulo: 67, id_modulo: 7 }, //sud_modulo y modulo
    test: false,
    datoLogin: sessionStorage, // variables de sesion del usuario
    ////////////////////////////////////////////////////////
    supervisionDocenteDirector,
    componentCalendar: "",
    ruta_api: API_URL + "/", // ruta del servidor
    ruta_api2: API_URL, // ruta del servidor
    compName2: null,
    estadoComponente: false,
    parametroComp: {},
    // consulta principal

    // variable iniciales
    inhabilitarGradoDoc: true,
    inhabilitarAreaDoc: true,
    inhabilitarCursoDoc: true,
    inhabilitarGrado: true,

    filtroProgDoc: [],
    nivelDoc: [],
    gradoDocFilter: [],
    areaDocFilter: [],
    cursoDocFilter: [],

    gradoDoc: [],
    areaDoc: [],
    cursoDoc: [],
    Docentes: [],
    NivelesDoc: [],
    GradosDoc: [],
    SeccionesDoc: [],
    AreasDoc: [],
    CursosDoc: [],
    ProgramacionDoc: [],

    gradoAsistencia: "",
    seccionAsistencia: "",
    asistentes: 0,
    id_seccion: null,

    paramsProgramacion: {
      id_colegio: sessionStorage.id_colegio,
      id_ano_lectivo: sessionStorage.id_ano_lectivo,
      id_personal: null,
      id_adm_nivel: "",
      id_adm_grado: "",
      id_seccion: "",
      id_adm_area: "",
      id_adm_curso: "",
    },
    paramsDocente: {
      id_colegio: sessionStorage.id_colegio,
      id_ano_lectivo: sessionStorage.id_ano_lectivo,
      id_persona: sessionStorage.id_persona,
      id_personal: null,
      id_adm_area: null,
      id_adm_grado: null,
    },
    progDocente: [],

    //validaciones de formulario
    rul: {
      required: (value) => !!value || "Campo Requerido",
      inputReq: (value) => !!value || "Campo Requerido",
      selectReq: (value) => !!value || "Debe seleccionar un campo de la lista",
      email: (value) =>
        /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.([a-zA-Z]{2,4})+$/.test(value) ||
        "El correo Electrónico es incorrecto",
      min4: (v) => (v || "").length >= 4 || "Mínimo 4 caracteres",
      min6: (v) => (v || "").length >= 6 || "Mínimo 6 caracteres",
      min8: (v) => (v || "").length >= 8 || "Mínimo 8 caracteres",
      max10: (v) => (v || "").length <= 10 || "Máximo 10 caracteres",
      max11: (v) => (v || "").length <= 11 || "Máximo 11 caracteres",
      max12: (v) => (v || "").length <= 12 || "Máximo 12 caracteres",
      max20: (v) => (v || "").length <= 20 || "Máximo 20 caracteres",
      max30: (v) => (v || "").length <= 30 || "Máximo 30 caracteres",
      max40: (v) => (v || "").length <= 40 || "Máximo 40 caracteres",
      max50: (v) => (v || "").length <= 50 || "Máximo 50 caracteres",
      max60: (v) => (v || "").length <= 60 || "Máximo 60 caracteres",
      max100: (v) => (v || "").length <= 100 || "Máximo 100 caracteres",
      max150: (v) => (v || "").length <= 150 || "Máximo 150 caracteres",

      email_null: (value) => {
        if (value == "") {
          return false;
        } else {
          const pattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.([a-zA-Z]{2,4})+$/;
          return pattern.test(value) || "El correo Electrónico es incorrecto";
        }
      },
    },


    search: "",
    filtroTabla: "",
    headers: [
      {
        text: "GRADO",
        value: "desc_grado",
        class: "secondary black--text",
      },
      {
        text: "AREA",
        value: "desc_area",
        class: "secondary black--text",
      },
      {
        text: "CLASE",
        value: "nombre_clase",
        class: "secondary black--text",
      },
      {
        text: "SECCIÓN",
        value: "nombre_seccion",
        class: "secondary black--text",
      },
      {
        text: "FECHA",
        value: "fecha",
        sortable: false,
        class: "secondary black--text",
      },
      {
        text: "HORA INICIO ",
        value: "horaIn",
        sortable: false,
        class: "secondary black--text",
      },
      {
        text: "HORA FIN",
        value: "horaFin",
        sortable: false,
        class: "secondary black--text",
      },
      {
        text: "ESTADO",
        value: "Estado",
        sortable: false,
        align: "center",
        class: "secondary black--text",
      },
      {
        text: "ASISTENCIA",
        value: "asistencia",
        sortable: false,
        align: "center",
        class: "secondary black--text",
      },
      {
        text: "VER CLASE",
        value: "action_ver",
        sortable: false,
        align: "center",
        class: "secondary black--text px-0 mx-0",
        width: "1",
      },
      {
        text: "SEGUIMIENTO",
        value: "seguimiento",
        sortable: false,
        align: "center",
        class: "secondary black--text px-0 mx-0",
        width: "1",
      },
      {
        text: "CLASE VIRTUAL",
        value: "action_clVirtual",
        sortable: false,
        class: "secondary black--text",
      },
      {
        text: "CLASE GRABADA",
        value: "action_video",
        sortable: false,
        class: "secondary black--text",
      },
      //{ text: 'ACCIONES', value: 'accion', sortable: false, align:'center', class:'secondary black--text'},

      //{ text: '', value: 'action', sortable: false, align:'center', class:'secondary black--text px-0 mx-0', width:'50'},
    ],
    /////////////////////////////////////

    // modal asociar clase
    modal_asociarClase: false,
    formTitle: "",
    asociarCl: [], // asociar Clases
    search_asociarCl: "",

    inhabilitarNivelCl: false,
    inhabilitarGradoCl: false,
    inhabilitarAreaCl: false,
    inhabilitarCursoCl: false,
    inhabilitarNivel: true,
    inhabilitarSeccion: true,

    nivelCont: [],
    id_nivelFiltro: "",

    gradoCont: [],
    id_gradoFiltro: [],

    gradoContFilter: [],

    areaCont: [],
    areaContFilter: [],
    id_areaFiltro: [],

    cursoCont: [],
    cursoContFilter: [],
    id_cursoFiltro: [],
    ////////////////////////////////////////

    // modal programar clase
    modal_programarClase: false,
    programarCl: {
      sesion_aprendizaje: null,
      tipo_contenido: null,
      clase_virtual: null,
      fecha: "",
      id_estado: "",
    },
    programarClCopia: [],

    inhabilitarFecha: false,
    inhabilitarHoraInicio: false,
    inhabilitarHoraFin: false,
    inhabilitarSesionAprendisaje: false,
    inhabilitarClaseVirtual: false,
    inhabilitarEnlaceVirtual: false,
    inhabilitarClaseVirtualEnlace: false,
    inhabilitarObservacion: false,

    nombreArchivoSubir: "",
    archivoSubir: null,
    evento: null,

    seccionDocFilter: [],
    seccionDoc: [],
    ///////////////////////////////////

    // modal confirmacion
    dialog_delete: false,
    desc_delete: null,
    id_delete: null,
    /////////////////////////

    //   tareas
    modal_tareas: false,
    Actividades: [],
    hoy: new Date(),
    headers_tareas: [
      { text: "APELLIDOS", value: "", class: "secondary black--text" },
      { text: "NOMBRES", value: "", class: "secondary black--text" },
      { text: "FECHA/HORA", value: "", class: "secondary black--text" },
      {
        text: "Respuesta del Alumno",
        value: "",
        class: "secondary black--text",
      },
      { text: "ADJUNTO", value: "", class: "secondary black--text" },
      {
        text: "Respuesta Docente",
        value: "",
        class: "secondary black--text",
      },
      { text: "Revisado", value: "", class: "secondary black--text" },
      { text: "CALIFICACIÓN", value: "", class: "secondary black--text" },
    ],
    /////////////////

    // asistencia
    modal_asistencia: false,
    Asistencias: [],
    headers_asistencia: [
      {
        text: "N° DE DOCUMENTO",
        value: "numdoc_alumno",
        class: "secondary black--text",
      },
      {
        text: "NOMBRES",
        value: "nombre_apellido_alumno",
        class: "secondary black--text",
      },
      {
        text: "ESTADO",
        value: "estadoAsistencia",
        align: "center",
        class: "secondary black--text",
      },
      {
        text: "OBSERVACIÓN",
        value: "observacion",
        class: "secondary black--text",
      },
      {
        text: "JUSTIFICACIÓN",
        value: "justificacion",
        class: "secondary black--text",
      },
    ],

    // modal  de seguimiento
    modal_seguimiento: false,
    seguimientoClase: [],
    ////////////////////////////////

    // visor de contenidos
    compName: "",
    estadoModalConfig: false,
    parametroConfigVisor: [],

    // modal visor de contenidos
    visor: false,
    api_list_contenidos: [],
    tipoVisor: "",
    ///////////////////////////

    //  modal reporte
    modal_reporte: false,
    contProgramada: 0,
    contReprogramada: 0,
    contSinejecutar: 0,
    contEjecutada: 0,
    contActualizada: 0,
    contNoProgramada: 0,

    //-- funciones del date picker de fecha
    dateFormatted: vm.formatDate(new Date().toISOString().substr(0, 10)),
    menu2: false,

    menu3: false,

    // modal sesion aprendizaje
    datosClase: {},
    totalClases: 1,
    modalSesion: false,
    sesionAprendizaje: { id: null },
    parametroSA: {},
    loadingSesionAprendizaje: true,
  }),

  computed: {
    ...mapGetters("login", ["componenteEvento"]),

    computedDateFormatted2() {
      return this.formatDate(this.programarCl.fecha);
    },

    rules() {
      const rules = [];

      if (
        this.programarCl.id_estado == 2 ||
        this.programarCl.id_estado == 5 ||
        this.programarCl.id_estado == null
      ) {
        const rule = (v) => !!v || "Campo Requerido";

        rules.push(rule);
      }

      return rules;
    },

    filteredData() {
      const searchTerm = this.filtroTabla.toLowerCase();
      const filteredItems = this.ProgramacionDoc.filter(item => {
        return (
          item.desc_grado.toLowerCase().includes(searchTerm) ||
          item.desc_area.toLowerCase().includes(searchTerm) ||
          item.nombre_clase.toLowerCase().includes(searchTerm) ||
          item.nombre_seccion.toLowerCase().includes(searchTerm) ||
          item.fecha.toLowerCase().includes(searchTerm) ||
          item.desc_estado.toLowerCase().includes(searchTerm) ||
          item.hora_inicio.toLowerCase().includes(searchTerm) ||
          item.hora_fin.toLowerCase().includes(searchTerm) ||
          item.desc_estado.toLowerCase().includes(searchTerm)
        );
      });

      return filteredItems;
    },
  },

  filters: {
    //-------------filtro para fechas -----------------------
    fechaTransform: function (string) {
      return string.replace(/^(\d{4})-(\d{2})-(\d{2})$/g, "$3/$2/$1");
    },
    //--------filtro para horas-----------------
    hora: function (hora) {
      let horaNew = parseInt(hora.substr(0, 2));
      let horaFormato = "";

      // si es pm
      if (horaNew >= 12) {
        if (horaNew == 12) {
          horaFormato = `${horaNew}:${hora.substr(3, 2)} PM`;
        } else if (horaNew > 12 && horaNew < 22) {
          horaFormato = `0${horaNew - 12}:${hora.substr(3, 2)} PM`;
        } else {
          horaFormato = `${horaNew - 12}:${hora.substr(3, 2)} PM`;
        }
      } else {
        if (horaNew == 0) {
          horaFormato = `12:${hora.substr(3, 2)} AM`;
        } else if (horaNew >= 1 && horaNew < 10) {
          horaFormato = `0${horaNew}:${hora.substr(3, 2)} AM`;
        } else {
          horaFormato = `${horaNew}:${hora.substr(3, 2)} AM`;
        }
      }

      if (!horaFormato) return null;
      //const [year, month, day] = date.split('-')
      return horaFormato;
    },
  },

  mounted() {
    this.loadMain();
    this.getAllProfesores();
  },

  created() {
    this.actualizarParamentro();
  },

  methods: {
    //////////////////////// NO MOVER CONFIGURACION PRINCIPAL DE CADA VISTA////////////////////////
    //  ------- MENSAJE DE SISTEMA  --------
    ...mapMutations("mensajeSis", ["setEnviarMens"]),

    //----- Validar accesos por perfil ------------
    ...mapActions("login", ["parametroComponente"]),
    moment(date = null) {
      if (date == null) {
        return moment();
      }
      return moment(date);
    },
    actualizarParamentro() {
      this.parametroComponente(this.paramComponente);
    },
    ////////////////////////////////////////////////////////
    verClaseVirtual(enlaceVirtual, fechaClase, horaInicio, horaFin,) {
    
      /////// FUNCION PARA TRAER FECHA ACTUAL
      function ckeckTime(i) {
        if (i < 10) {
          i = "0" + i;
        }
        return i;
      }


      //validamoque la fecha no se mayor ni menor
      let fecha_actual = moment().format("YYYY-MM-DD");
     
      if (fecha_actual < fechaClase) {
        this.setEnviarMens({
          tipo: "E",
          mensaje: `La clase no ha iniciado`,
          tiempo: null,
        });
    
      } else if (fecha_actual > fechaClase) {
        this.setEnviarMens({
          tipo: "E",
          mensaje: `La clase ya culminó`,
          tiempo: null,
        });

      } else {
     
        let hora = new Date();
        let horaHora = ckeckTime(hora.getHours());
        let horaMin = ckeckTime(hora.getMinutes());
        let horaActual = `${horaHora}:${horaMin}:00`;
        var mensaje = "";
        var error = 0;

        if (horaActual < horaInicio) {
          mensaje += "La Clase no ha iniciado";
          error = 1;
        }

        if (horaActual > horaFin) {
          mensaje += "La Clase ya culminó";
          error = 1;
        }

        if (error == 0) {
          //this.setEnviarMens({tipo:"S", mensaje: `Activar Link`, tiempo:null})
          window.open(enlaceVirtual);
        } else {
          this.setEnviarMens({
            tipo: "E",
            mensaje: `${mensaje}`,
            tiempo: null,
          });
        }
      }
    },

    //// modal calendario
    ...mapMutations("progDocente", ["setActivarCalendario"]),

    //  ------- input tipo fecha  --------
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    parseDate(date) {
      if (!date) return null;

      const [month, day, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },

    //Traer a todos los docentes de ese colegio
    async getAllProfesores() {
      try {
        const response = await axios.post(
          "/academico/director/alldocentes/",
          this.paramsDocente
        );
        this.Docentes = response.data;
      } catch (error) {
        console.log(error);
      }
    },

    //Traer todos los niveles del docente
    async getNivelesDocente(id) {
      this.paramsProgramacion.id_adm_nivel = "";
      this.paramsProgramacion.id_adm_grado = "";
      this.paramsProgramacion.id_seccion = "";
      this.paramsProgramacion.id_adm_area = "";
      this.paramsProgramacion.id_adm_curso = "";
      this.filtroProgDoc.id_grado = null;
      this.filtroProgDoc.id_nivel = null;
      this.inhabilitarGrado = true;
      this.filtroProgDoc.id_area = null;
      this.inhabilitarAreaDoc = true;
      this.id_seccion = null;
      this.inhabilitarSeccion = true;
      this.filtroProgDoc.id_curso = null;
      this.inhabilitarCursoDoc = true;

      this.paramsDocente.id_personal = id;
      this.paramsDocente.id_persona_coordinador = this.datoLogin.id_persona;
      this.inhabilitarNivel = false;
      try {
        const response = await axios.post(
          "/academico/director/allnivelesDocentes/",
          this.paramsDocente
        );

   

        this.NivelesDoc = response.data;
        this.inhabilitarGradoDoc = false;
        await this.getAllProgramacionDocente(id);
        let arrIdsNiveles = [];
        for (const item of this.NivelesDoc) {
          arrIdsNiveles.push(item.id_adm_nivel);
        }
        this.ProgramacionDoc = this.ProgramacionDoc.filter((el) =>
          arrIdsNiveles.includes(el.id_nivel)
        );
        this.reporte(this.ProgramacionDoc);

      } catch (error) {
        console.log(error);
      }
    },

    //Traer todos los grados del docente
    async getGradosDocente(id) {
      this.id_seccion = null;
      this.inhabilitarSeccion = true;
      this.filtroProgDoc.id_area = null;
      this.inhabilitarAreaDoc = true;
      this.filtroProgDoc.id_curso = null;
      this.inhabilitarCursoDoc = true;
      this.GradoDoc = [];
      this.SeccionDoc = [];
      this.AreaDoc = [];
      this.CursoDoc = [];
      this.paramsProgramacion.id_adm_grado = "";
      this.paramsProgramacion.id_seccion = "";
      this.paramsProgramacion.id_adm_area = "";
      this.paramsProgramacion.id_adm_curso = "";
      this.inhabilitarGrado = false;
      this.inhabilitarGradoDoc = true;
      this.paramsDocente.id_adm_nivel = id;
      this.paramsProgramacion.id_adm_nivel = id;
      try {
        const response = await axios.post(
          "/academico/coordinador/all/gd/",
          this.paramsDocente
        );
        this.GradosDoc = response.data;
        this.getAllProgramacionDocente(this.paramsDocente.id_personal);

      } catch (error) {
        console.log(error);
      }
    },

    //Traer todos los areas del docente
    async getAllAreasDocente(id) {
      this.paramsProgramacion.id_seccion = "";
      this.paramsProgramacion.id_adm_area = "";
      this.paramsProgramacion.id_adm_curso = "";
      this.paramsDocente.id_adm_grado = id;
      this.paramsProgramacion.id_adm_grado = id;
      try {
        const response = await axios.post(
          "/academico/coordinador/all/area/docente/",
          this.paramsDocente
        );
        this.AreasDoc = response.data;
        this.inhabilitarAreaDoc = false;
        this.inhabilitarSeccion = false;
        this.getSeccionesDocente();
        this.getAllProgramacionDocente(this.paramsDocente.id_personal);

      } catch (error) {
        console.log(error);
      }
    },

    //Traer todos los cursos del docente
    async getCursosDocente(id) {
      this.paramsProgramacion.id_adm_curso = "";
      this.paramsDocente.id_adm_area = id;
      this.paramsProgramacion.id_adm_area = id;
      this.CursoDoc = [];
      try {
        const response = await axios.post(
          "/academico/coordinador/all/cd/",
          this.paramsDocente
        );
        this.CursosDoc = response.data;
        this.inhabilitarCursoDoc = false;
        this.getAllProgramacionDocente(this.paramsDocente.id_personal);

      } catch (error) {
        console.log(error);
      }
    },

    //Traer todos las secciones del docente
    async getSeccionesDocente() {
      try {
        const response = await axios.post(
          "/academico/coordinador/all/cs/",
          this.paramsDocente
        );
        this.SeccionesDoc = response.data;

      } catch (error) {
        console.log(error);
      }
    },

    //Traer las programaciones del docente
    async getAllProgramacionDocente(id) {
      this.paramsProgramacion.id_personal = id;
      this.paramsProgramacion.id_persona_coordinador = this.datoLogin.id_persona;
      try {
        const response = await axios.post(
          "/academico/coordinador/all/pg/dc/",
          this.paramsProgramacion
        );

        this.ProgramacionDoc = response.data;
        this.reporte(this.ProgramacionDoc);
      } catch (error) {
        console.log(error);
      }
    },
    async getAllProgramacionSeccion(id) {
      this.paramsProgramacion.id_adm_area = "";
      this.paramsProgramacion.id_adm_curso = "";
      this.inhabilitarCursoDoc = true;
      this.paramsProgramacion.id_seccion = id;
      await this.getAllProgramacionDocente(this.paramsProgramacion.id_personal);
    },

    //Traer la asistencia
    async getAllAsistencia(item) {
      try {
        var inasistencias = 0;
        let params = {
          id_colegio: sessionStorage.id_colegio,
          id_ano_lectivo: sessionStorage.id_ano_lectivo,
          id_programacion_docente: item.id,
        };
        const response = await axios.post(
          "/academico/coordinador/all/pg/dc/ass/",
          params
        );
        this.Asistencias = response.data;
        this.gradoAsistencia = item.desc_grado;
        this.seccionAsistencia = item.nombre_seccion;
        for (var i = 0; i < this.Asistencias.length; i++) {
          if (this.Asistencias[i].estado_asistencia === null) {
            inasistencias = inasistencias + 1;
          }
        }
        this.asistentes = this.Asistencias.length - inasistencias;
        this.modal_asistencia = true;
  
      } catch (error) {
        console.log(error);
      }
    },
    async verSeguimiento(item) {
      try {
        let response = await axios.get(
          "/academico/coordinador//all/hist/pg/" + item.id + ""
        );
        this.seguimientoClase = response.data;
        this.modal_seguimiento = true;
      } catch (error) {
        console.log(error);
      }
    },
    closeModalCalendar() {
      this.componentCalendar = "";
    },
    reporte(item) {
      var cP = 0;
      var cE = 0;
      var cR = 0;
      var cS = 0;
      var cA = 0;
      var cnp = 0;

      for (var i = 0; i < item.length; i++) {
        switch (item[i].id_estado) {
          case 1:
            cP = cP + 1;
            break;
          case 2:
            cR = cR + 1;
            break;
          case 3:
            cS = cS + 1;
            break;
          case 4:
            cE = cE + 1;
            break;
          case 5:
            cA = cA + 1;
            break;
          case null:
            cnp = cnp + 1;
            break;
          default:
            break;
        }
      }
      this.contEjecutada = cE;
      this.contProgramada = cP;
      this.contReprogramada = cR;
      this.contSinejecutar = cS;
      this.contActualizada = cA;
      this.contNoProgramada = cnp;
    },
    closeModalReporte() {
      this.modal_reporte = false;
      this.contSinejecutar = 0;
      this.contEjecutada = 0;
      this.contProgramada = 0;
      this.contReprogramada = 0;
      this.contActualizada = 0;
      this.contNoProgramada = 0;
    },

    //////////////////////////////////////////////////////////////////////////////////////

    //  ------- Cargar todos los registros principales al iniciar el componente   --------
    async loadMain() {
      try {
        let params = `/periodo/${this.datoLogin.id_ano_lectivo}/colegio/${this.datoLogin.id_colegio}/usuario/${this.datoLogin.id}`;
        let response = await axios.get(
          `/academico/progDocente/getQuery${params}`
        );
        let data = response.data;
        this.nivelDoc = data.payload.NivelDoc;
        this.gradoDoc = data.payload.GradoDoc;
        this.areaDoc = data.payload.AreaDoc;
        this.cursoDoc = data.payload.CursoDoc;
        this.seccionDoc = data.payload.SeccionDoc;
        this.progDocente = data.payload.ProgDocente;
      } catch (error) {
        this.setEnviarMens({
          tipo: "E",
          mensaje: `Error: ${error}`,
          tiempo: null,
        });
      
      }
    },

    //  manejador del evento nivel de la programacion de clase
    eventNivelDoc() {
      this.inhabilitarGradoDoc = false;
      this.inhabilitarAreaDoc = true;
      this.inhabilitarCursoDoc = true;

      // filtro y cargo los valores del grado segun el nivel
      //let filtro = this.asociarCl.id_nivel

      this.gradoDocFilter = this.gradoDoc.filter(
        (el) => el.id_nivel == this.filtroProgDoc.id_nivel
      );
    },

    // manejador del evento grado de la programacion de clase
    eventGradoDoc() {
      this.inhabilitarAreaDoc = false;
      this.inhabilitarCursoDoc = true;

      this.areaDocFilter = this.areaDoc.filter(
        (el) => el.id_grado == this.filtroProgDoc.id_grado
      );
    },

    // manejador del evento area de programacion de clase
    eventAreaDoc() {
      this.inhabilitarCursoDoc = false;

      //this.cargarClases()
      // filtro y cargo los valores del los curso segun el grado
      this.cursoDocFilter = this.cursoDoc.filter(
        (el) => el.id_area == this.filtroProgDoc.id_area
      );
    },

    // manejador del evento area de programacion de clase
    eventCursoDoc() {
      this.seccionDocFilter = this.seccionDoc.filter(
        (el) => el.id_curso == this.filtroProgDoc.id_curso
      );

      //this.cargarClases()
      // filtro y cargo los valores del los curso segun el grado
      //this.cursoDocFilter = this.cursoDoc.filter(el=>el.id_area == this.filtroProgDoc.id_area)
    },

    // inicia la modal asociar clase
    asociarClase() {
      if (
        this.filtroProgDoc.id_curso == "" ||
        this.filtroProgDoc.id_curso == null
      ) {
        this.setEnviarMens({
          tipo: "W",
          mensaje: `Debe seleccionar un Curso`,
          tiempo: null,
        });
      } else {
        this.modal_asociarClase = true;
        this.formTitle = "Asociar Clase";
        (this.asociarCl = {
          contenidoTipo: null,
          id_nivel: "",
          id_grado: "",
          id_area: "",
          id_curso: "",
        }),
          (this.clases = []);
        this.clasesColegio = [];
        this.inhabilitarNivelCl = true;
        this.inhabilitarGradoCl = true;
        this.inhabilitarAreaCl = true;
        this.inhabilitarCursoCl = true;
      }
    },

    // carga la consultas de contenido de ck1 o del colegio segun el tipo de contenido seleccinado (ck1 o colegio)
    async cargarQueryContenido() {
      try {
        this.clases = [];
        this.asociarCl.id_nivel = "";
        this.asociarCl.id_grado = "";
        this.asociarCl.id_area = "";
        this.asociarCl.id_curso = "";

        this.inhabilitarNivelCl = false;
        this.inhabilitarGradoCl = true;
        this.inhabilitarAreaCl = true;
        this.inhabilitarCursoCl = true;

        // contenido clicken 1
        if (this.asociarCl.contenidoTipo == "1") {
          this.id_nivelFiltro = "id";
          this.id_gradoFiltro = "id";
          this.id_areaFiltro = "id";
          this.id_cursoFiltro = "id";

          this.tablaCk1 = true;
          this.tablaColegio = false;

          let response = await axios.get(
            `/academico/progDocente/getQueryContCk1`
          );
          //alert(JSON.stringify(response.data))

          this.nivelCont = response.data.NivelCkOne;
          this.gradoCont = response.data.GradoCkOne;
          this.areaCont = response.data.AreaCkOne;
          this.cursoCont = response.data.CursoCkOne;

          // contenido del colegio
        } else if (this.asociarCl.contenidoTipo == "0") {
          this.id_nivelFiltro = "id_nivel";
          this.id_gradoFiltro = "id_grado";
          this.id_areaFiltro = "id_area";
          this.id_cursoFiltro = "id_curso";

          this.tablaCk1 = false;
          this.tablaColegio = true;

          await this.cargarFiltros();

          this.asociarCl.id_nivel = this.filtroProgDoc.id_nivel;
          this.eventNivelCl();

          this.asociarCl.id_grado = this.filtroProgDoc.id_grado;
          this.eventGradoCl();

          this.asociarCl.id_area = this.filtroProgDoc.id_area;
          this.eventAreaCl();

          this.asociarCl.id_curso = this.filtroProgDoc.id_curso;
          this.cargarClases();

          /* this.programarCl.id_grado    = this.filtroProgDoc.id_grado
                        this.programarCl.id_area     = this.filtroProgDoc.id_area
                        this.programarCl.id_curso    = this.filtroProgDoc.id_curso */

          //var url = "/academico/progDocente/getQueryContColegio"
        }
      } catch (error) {
        this.setEnviarMens({
          tipo: "E",
          mensaje: `Error: ${error}`,
          tiempo: null,
        });
      }
    },

    cargarFiltros() {
      this.nivelCont = this.nivelDoc;
      this.gradoCont = this.gradoDoc;
      this.areaCont = this.areaDoc;
      this.cursoCont = this.cursoDoc;
    },

    // carga las clases de los gestor de contenidos segun los filtros seleccionados
    async cargarClases() {
      try {
        this.asociarCl.periodo = this.datoLogin.id_ano_lectivo;

        // contenido clicken 1
        if (this.asociarCl.contenidoTipo == "1") {
          let response = await axios.post(
            `/academico/progDocente/getClasesCk1`,
            this.asociarCl
          );

          this.clases = response.data;

          // contenido del colegio
        } else if (this.asociarCl.contenidoTipo == "0") {
          let response = await axios.get(
            `/academico/progDocente/getContenidoColegio/colegio/${this.datoLogin.id_colegio}/nivel/${this.asociarCl.id_nivel}/grado/${this.asociarCl.id_grado}/area/${this.asociarCl.id_area}/curso/${this.asociarCl.id_curso}/usuario/${this.datoLogin.id}`
          );

          this.clasesColegio = response.data.ContenidoColegio;
        }
      } catch (error) {
        this.setEnviarMens({
          tipo: "E",
          mensaje: `Error: ${error}`,
          tiempo: null,
        });
      }
    },

    //  manejador del evento nivel de la programacion de clase
    eventNivelCl() {
      this.inhabilitarGradoCl = false;
      this.inhabilitarAreaCl = true;
      this.inhabilitarCursoCl = true;
      this.clases = [];
      this.clasesColegio = [];

      // filtro y cargo los valores del grado segun el nivel
      //let filtro = this.asociarCl.id_nivel
      this.gradoContFilter = this.gradoCont.filter(
        (el) => el.id_nivel == this.asociarCl.id_nivel
      );
    },

    // manejador del evento grado de la programacion de clase
    eventGradoCl() {
      this.inhabilitarAreaCl = false;
      this.inhabilitarCursoCl = true;
      this.clases = [];
      this.clasesColegio = [];

      if (this.asociarCl.contenidoTipo == "1") {
        this.areaContFilter = this.areaCont;

        // contenido del colegio
      } else if (this.asociarCl.contenidoTipo == "0") {
        this.areaContFilter = this.areaCont.filter(
          (el) => el.id_grado == this.asociarCl.id_grado
        );
      }
    },

    // manejador del evento area de programacion de clase
    eventAreaCl() {
      this.inhabilitarCursoCl = false;

      this.clases = [];
      this.clasesColegio = [];
      //this.cargarClases()
      // filtro y cargo los valores del los curso segun el grado
      let resultFiltroCurso = this.cursoCont.filter(
        (el) => el.id_area == this.asociarCl.id_area
      );
      this.cursoContFilter = resultFiltroCurso.filter(
        (el) => el.id_grado == this.asociarCl.id_grado
      );
    },

    limpiarForm() {
      this.programarCl = {
        id: null,
        sesion_aprendizaje: null,
        tipo_contenido: null,
        titulo: "",
        sub_titulo: "",
        nombre_tema: "",
        nombre_clase: "",
        id_clase: "",
        id_nivel: "",
        id_grado: "",
        id_area: "",
        id_curso: "",
        id_seccion: "",
        fecha: "",
        hora_inicio: "",
        hora_fin: "",
        enlace_sesion: "",
        apoyo_docente_ruta: "",
        apoyo_docente_nombre: "",
        nombre_uri: "",
        clase_virtual: null,
        enlace_virtual: null,
        clase_virtual_video: "",
        enlace_virtual_video_enlace: null,
        observacion: "",
        id_estado: null,
        desc_estado: "",
        color_estado: "",
      };

      this.archivoSubir = null;

      // inhabilitar campos de porgramacion docente Agregar o editar
      this.inhabilitarFecha = false;
      this.inhabilitarHoraInicio = false;
      this.inhabilitarHoraFin = false;
      this.inhabilitarSesionAprendisaje = false;
      this.inhabilitarClaseVirtual = false;
      this.inhabilitarEnlaceVirtual = false;
      this.inhabilitarClaseVirtualEnlace = false;
      this.inhabilitarObservacion = false;

      this.$refs.formDatosProgramar.resetValidation();
    },

    // Levanta la modal para programar la clase  (agregar)
    addItem(items) {
      //alert(JSON.stringify(items))
      this.limpiarForm();

      this.programarCl.titulo = "Crear Programación de Clase";
      this.programarCl.nombre_tema = items.nombre_tema;
      this.programarCl.nombre_clase = items.nombre_clase;
      this.modal_programarClase = true;
      this.evento = "agregar";
      this.programarCl.tipo_contenido = this.asociarCl.contenidoTipo;
      this.programarCl.id_clase = items.id_clase;
      this.programarCl.sesion_aprendizaje = items.sesion;
      this.programarCl.clase_virtual = 0;
      this.programarCl.clase_virtual_video = 0;

      // parametrizacion previa de programacion docente
      this.programarCl.desc_estado = "Programada";
      this.programarCl.color_estado = "6d6d6d";
      this.programarCl.id_nivel = this.filtroProgDoc.id_nivel;
      this.programarCl.id_grado = this.filtroProgDoc.id_grado;
      this.programarCl.id_area = this.filtroProgDoc.id_area;
      this.programarCl.id_curso = this.filtroProgDoc.id_curso;
    },

    //  manejador del evento nivel de la programacion de clase
    eventNivelDocCl() {
      // filtro y cargo los valores del grado segun el nivel
      //let filtro = this.asociarCl.id_nivel
      this.gradoDocFilter = this.gradoDoc.filter(
        (el) => el.id_nivel == this.programarCl.id_nivel
      );
    },

    // manejador del evento grado de la programacion de clase
    eventGradoDocCl() {
      this.areaDocFilter = this.areaDoc.filter(
        (el) => el.id_grado == this.programarCl.id_grado
      );
    },

    // manejador del evento area de programacion de clase
    eventAreaDocCl() {
      //this.cargarClases()
      // filtro y cargo los valores del los curso segun el grado
      this.cursoDocFilter = this.cursoDoc.filter(
        (el) => el.id_area == this.programarCl.id_area
      );
    },

    // manejador del evento area de programacion de clase
    eventCursoDocCl() {
      this.seccionDocFilter = this.seccionDoc.filter(
        (el) => el.id_curso == this.programarCl.id_curso
      );

      //this.cargarClases()
      // filtro y cargo los valores del los curso segun el grado
      //this.cursoDocFilter = this.cursoDoc.filter(el=>el.id_area == this.programarCl.id_area)
    },

    // botos para visualizar clases de la programacion de contenido
    gestionContenido() {
      this.setEnviarMens({
        tipo: "W",
        mensaje: `Modulo en Construccion por el Ing. Jose Guardia  `,
        tiempo: null,
      });
    },

    // replicar la clase del docente ya programada
    async replicarClase(items) {
      await this.limpiarForm();

      this.gradoDocFilter = this.gradoDoc.filter(
        (el) => el.id_nivel == items.id_nivel
      );
      this.areaDocFilter = this.areaDoc.filter(
        (el) => el.id_grado == items.id_grado
      );
      this.cursoDocFilter = this.cursoDoc.filter(
        (el) => el.id_area == items.id_area
      );
      this.seccionDocFilter = this.seccionDoc.filter(
        (el) => el.id_curso == items.id_curso
      );

      // asignacion de variables de replicación
      this.programarCl.titulo = "Replicar Programación de clase";
      this.programarCl.nombre_tema = items.nombre_tema;
      this.programarCl.nombre_clase = items.nombre_clase;
      this.modal_programarClase = true;
      this.evento = "agregar";
      this.programarCl.tipo_contenido = items.tipo_contenido;
      this.programarCl.desc_estado = items.desc_estado;
      this.programarCl.color_estado = items.color_estado;

      //asociarCl.contenidoTipo
      this.programarCl.id_clase = items.id_clase;
      this.programarCl.sesion_aprendizaje = items.sesion;
      this.programarCl.id_nivel = items.id_nivel;
      this.programarCl.id_grado = items.id_grado;
      this.programarCl.id_area = items.id_area;
      this.programarCl.id_curso = items.id_curso;

      this.programarCl.clase_virtual = 0;
      this.programarCl.clase_virtual_video = 0;
      /* this.programarCl.clase_virtual  = items.clase_virtual
                this.programarCl.enlace_virtual = items.enlace_virtual */
    },

    /*  async verSeguimiento(id){
                this.modal_seguimiento = true

                let response = await axios.get("/academico/progDocente/getSeguimiento/"+id)
                this.seguimientoClase = response.data.Seguimiento
            },**/

    // Levanta la modal para programar la clase  (agregar)
    editItem(items) {
      this.limpiarForm();

      this.gradoDocFilter = this.gradoDoc.filter(
        (el) => el.id_nivel == items.id_nivel
      );
      this.areaDocFilter = this.areaDoc.filter(
        (el) => el.id_grado == items.id_grado
      );
      this.cursoDocFilter = this.cursoDoc.filter(
        (el) => el.id_area == items.id_area
      );
      this.seccionDocFilter = this.seccionDoc.filter(
        (el) => el.id_curso == items.id_curso
      );

      // asignacion de variables de replicación
      this.programarCl.titulo = "Editar Programación de clase";
      this.programarCl.id = items.id;
      this.programarCl.nombre_tema = items.nombre_tema;
      this.programarCl.nombre_clase = items.nombre_clase;
      this.modal_programarClase = true;
      this.evento = "editar";
      this.programarCl.tipo_contenido = items.tipo_contenido;
      this.programarCl.uri =
        this.ruta_api + items.apoyo_docente_ruta + items.apoyo_docente_nombre;
      this.programarCl.enlace_sesion = items.enlace_virtual;

      //asociarCl.contenidoTipo
      this.programarCl.id_clase = items.id_clase;
      this.programarCl.sesion_aprendizaje = items.sesion;
      this.programarCl.id_nivel = items.id_nivel;
      this.programarCl.id_grado = items.id_grado;
      this.programarCl.id_area = items.id_area;
      this.programarCl.id_curso = items.id_curso;
      this.programarCl.id_seccion = items.id_seccion;
      this.programarCl.clase_virtual = items.clase_virtual;
      this.programarCl.enlace_virtual = items.enlace_virtual;
      this.programarCl.clase_virtual_video = items.clase_virtual_video;
      this.programarCl.clase_virtual_video_enlace = items.clase_virtual_video_enlace;
      this.programarCl.fecha = items.fecha;
      this.programarCl.hora_inicio = items.hora_inicio;
      this.programarCl.hora_fin = items.hora_fin;
      this.programarCl.desc_estado = items.desc_estado;
      this.programarCl.color_estado = items.color_estado;
      this.programarCl.id_estado = 5;

      // Bloquear Campos de programacion docente
      this.inhabilitarFecha = true;
      this.inhabilitarHoraInicio = false;
      this.inhabilitarHoraFin = false;
      this.inhabilitarSesionAprendisaje = false;
      this.inhabilitarClaseVirtual = false;
      this.inhabilitarEnlaceVirtual = false;
      this.inhabilitarClaseVirtualEnlace = true;
      this.inhabilitarObservacion = false;

      this.programarClCopia = items;

      this.actualizarDatos();
    },

    actualizarDatos() {
      this.programarCl.fecha = this.programarClCopia.fecha;
      this.programarCl.hora_inicio = this.programarClCopia.hora_inicio;
      this.programarCl.hora_fin = this.programarClCopia.hora_fin;
      this.programarCl.clase_virtual = this.programarClCopia.clase_virtual;
      this.programarCl.enlace_virtual = this.programarClCopia.enlace_virtual;
      this.programarCl.clase_virtual_video = this.programarClCopia.clase_virtual_video;
      this.programarCl.enlace_virtual_video_enlace = this.programarClCopia.enlace_virtual_video_enlace;
      this.archivoSubir = null;
    },

    // manejador del evento para la edición (Actualizar)
    eventActualizar() {
      // habilito todos los campos
      this.inhabilitarFecha = true;

      this.inhabilitarHoraInicio = false;
      this.inhabilitarHoraFin = false;
      this.inhabilitarSesionAprendisaje = false;
      this.inhabilitarClaseVirtual = false;
      this.inhabilitarEnlaceVirtual = false;
      this.inhabilitarClaseVirtualEnlace = false;
      this.inhabilitarObservacion = false;

      this.actualizarDatos();
    },

    // manejador del evento para la edición (reprogramar)
    eventReprogramar() {
      // habilito todos los campos

      this.inhabilitarFecha = false;
      this.inhabilitarHoraInicio = false;
      this.inhabilitarHoraFin = false;
      this.inhabilitarSesionAprendisaje = false;
      this.inhabilitarClaseVirtual = false;
      this.inhabilitarEnlaceVirtual = false;
      this.inhabilitarClaseVirtualEnlace = true;
      this.inhabilitarObservacion = false;

      this.actualizarDatos();
    },

    // manejador del evento para la edición (reprogramar)
    async eventEjecutar() {
      this.habilitarSave = true;

      // Bloquear Campos de programacion docente
      this.inhabilitarFecha = true;
      this.inhabilitarHoraInicio = true;
      this.inhabilitarHoraFin = true;
      this.inhabilitarSesionAprendisaje = true;
      this.inhabilitarClaseVirtual = true;
      this.inhabilitarEnlaceVirtual = true;
      this.inhabilitarClaseVirtualEnlace = false;
      this.inhabilitarObservacion = false;

      await this.actualizarDatos();

      // activo el video virtual
      if (
        this.programarCl.id_estado == 4 &&
        this.programarCl.clase_virtual == 1
      ) {
        this.programarCl.clase_virtual_video = 1;
      }
    },

    async saveItem() {
      //this.setEnviarMens({tipo:"W", mensaje: `Guardar Archivo`, tiempo:null})
      if (this.$refs.formDatosProgramar.validate()) {
        try {
          //let params = this.datos
          this.programarCl.periodo = this.datoLogin.id_ano_lectivo;
          this.programarCl.usuario = this.datoLogin.id;
          this.programarCl.id_colegio = this.datoLogin.id_colegio;

          var res = "";
          if (this.evento == "agregar") {
            res = await axios.post("/academico/progDocente/", this.programarCl);
          }

          if (this.evento == "editar") {
            res = await axios.put(
              "/academico/progDocente/" + this.programarCl.id,
              this.programarCl
            );
            //    var res = await axios.put("/sistema/usuarioManager/"+this.datos.id,this.datos)
          }

          this.setEnviarMens({
            tipo: res.data.messageT,
            mensaje: res.data.message,
            tiempo: null,
          });

          if (res.data.messageT == "S") {
            this.modal_programarClase = false;
            this.cargarClases();
            this.loadMain();

            // si existe un archivo se sube y se actualiza la nueva uri
            if (this.archivoSubir) {
              this.saveFile(res.data.lastInsert);
            }
          }
        } catch (error) {
          this.setEnviarMens({
            tipo: "E",
            mensaje: `${error}`,
            tiempo: null,
          });
        }
      }
    },

    async saveFile(id) {
      if (!this.archivoSubir) {
        this.setEnviarMens({
          tipo: "W",
          mensaje: `Debe subir un archivo `,
          tiempo: null,
        });
      } else {
        try {
          let formData = new FormData();
          formData.append("subirArchivo", this.archivoSubir);
          formData.append("usuario", this.datoLogin.id);
          formData.append("colegio", this.datoLogin.id_colegio);
          formData.append("periodo", this.datoLogin.id_ano_lectivo);
          formData.append("nivel", this.programarCl.id_nivel);
          formData.append("grado", this.programarCl.id_grado);
          formData.append("seccion", this.programarCl.id_seccion);
          formData.append("curso", this.programarCl.id_curso);
          formData.append("id_programacion", id);

          await axios.post(
            "/academico/progDocente/addSesionAprendisaje",
            formData,
            {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            }
          );

          // this.setEnviarMens({tipo:response.data.messageT, mensaje: `${response.data.message}`, tiempo:null})
          this.modal_programarClase = false;
        } catch (error) {
          this.setEnviarMens({
            tipo: "E",
            mensaje: `${error}`,
            tiempo: null,
          });
        }
      }
    },

    // componente de  calendario
    verCalendario() {
      this.setActivarCalendario({ periodo: this.paramsDocente.id_ano_lectivo, id_docente: this.paramsDocente.id_personal });
      this.componentCalendar = "Calendario";
    },


    // Generar reporte de Horario de clases
    async generarExcel() {
      // this.setActivarCalendario({ periodo: this.paramsDocente.id_ano_lectivo, id_docente: this.paramsDocente.id_personal });

      try {
        // this.generandoReporte = 1
        if (this.id_seccion == null || this.id_seccion == "") {
          this.setEnviarMens({ tipo: 'W', mensaje: 'Debe seleccionar una Sección', tiempo: 3000 })
          this.generandoReporte = 0
          return false
        }
        this.setEnviarMens({ tipo: 'S', mensaje: 'Generando horario…', tiempo: 3000 })

        let codigoReporte = "horario_docente";
        let data = {};
        let archivoADescargar = '';


        data = {
          anioLectivo: parseInt(this.datoLogin.id_ano_lectivo),
          nivel: parseInt(this.filtroProgDoc.id_nivel),
          grado: parseInt(this.filtroProgDoc.id_grado),
          seccion: parseInt(this.id_seccion),
          area: parseInt(this.filtroProgDoc.id_area),
          curso: parseInt(this.filtroProgDoc.id_curso),
          docente: parseInt(this.filtroProgDoc.id),


        }
        data.BUCKET_ORIGIN_SPACE = BUCKET_ORIGIN_SPACE
        data.colegio = parseInt(sessionStorage.getItem('id_colegio'))
        data.tamanioPorHoja = 50
        data.codigoReporte = codigoReporte

        //generamos el reporte
        let response = await axios.post("/reporte/formatoReporte/generarReporte", data);
        let dataResponse = response.data

        this.setEnviarMens({ tipo: dataResponse.messageT, mensaje: dataResponse.message, tiempo: 3000 })

        this.generandoReporte = 0
        if (dataResponse.messageT == 'S') {
          archivoADescargar = dataResponse.fileToDownload;
          axios({
            url: '/reporte/formatoReporte/bajarReporte/' + dataResponse.nameReport,
            method: 'GET',
            responseType: 'blob', // important
          }).then((response) => {
            this.setEnviarMens({ tipo: 'S', mensaje: 'Horario de docente generado.', tiempo: 3000 })

            const url = window.URL.createObjectURL(new Blob([response.data]));
    
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', archivoADescargar);
            document.body.appendChild(link);
            link.click();
            link.remove()
            window.URL.revokeObjectURL(url);
          });

        }

      } catch (e) {
        console.log(e)
        this.setEnviarMens({ tipo: 'E', mensaje: 'No se pudo generar el reporte. Por favor, vuelva a intentarlo.', tiempo: 3000 })
      }
    },

    // activa la modal para confirmar el borrar el registro
    deleteConfirm(items) {
      this.dialog_delete = true;
      this.id_delete = items.id;
      this.desc_delete = `Tema: ${items.nombre_tema}, fecha:${items.fecha},Hora ${items.hora_inicio} - (${items.id})`;
    },

    //------------BORRAR Registro -------------
    async deleteItem() {
      this.dialog_delete = false;
      try {
        let resp = await axios.delete(
          "/academico/progDocente/" + this.id_delete
        );
        this.loadMain();
        this.dialog = false;
        this.setEnviarMens({
          tipo: resp.data.messageT,
          mensaje: resp.data.message,
          tiempo: null,
        });
      } catch (error) {
        this.setEnviarMens({
          tipo: "E",
          mensaje: `${error}`,
          tiempo: null,
        });
      }
    },
    // botos para visualizar clases de la programacion de contenido
    async visualizarClase(id_clase, tipo_contenido) {

      this.parametroComp = {
        evento: "visualizar",
        id_clase,
        miniatura: false,
        id_diapositiva: 1,
        tipo_contenido: tipo_contenido == 1 ? "manager" : "administrativo"
      }
      this.estadoComponente = true
      this.compName2 = "visorContenido"

    },


    CloseModal() {
      this.estadoComponente = false
    },



    // funcion para cerrar modal
    cerrarVisor() {
      this.visor = false;
      this.api_list_contenidos = [];
      this.tipoVisor = "";
      //this.setCloseVisor()
    },


    async GenerarDocumentoSa(id_sa) {

  
      try {
        // SA de programacion Docente
        let api_sa = `/academico/sesionAprendizajeProg/${id_sa}/documento/`
        const params = { id_colegio: this.datoLogin.id_colegio }
        let res = await axios.post(api_sa, params, { responseType: "blob" })
        var fileURL = window.URL.createObjectURL(new Blob([res.data]))
        var fileLink = document.createElement("a")
        fileLink.href = fileURL
        fileLink.setAttribute("download", `sesion_aprendizaje_${id_sa}.pdf`)
        document.body.appendChild(fileLink)
        fileLink.click()
      } catch (error) {
        console.log(error);
        this.setEnviarMens({ tipo: "E", mensaje: `Error al generar el documento`, tiempo: null })
      }

    },

  },
};
</script>
